import { config } from "../constants";
import axios from "../utils/axios";
import { toast } from "react-toastify";

export const fetchLogsService = async (data) => {
  try {
    const response = await axios.post(
      `${config.url.AIRFLOW}/api/airflow/get_logs`,
      data
    );

    const logs = response.data.logs;
    return logs;
  } catch (_) {}
};

export const getTargetDAGDataService = async () => {
  const toastID = toast.loading("Retrieving job data");
  let response;

  try {
    response = await axios.post(
      `${config.url.AIRFLOW}/api/airflow/list_dags`,
      {
        dag_type: "all",
      }
    );
  } catch (_) {
    toast.error("Error while loading scheduled jobs.");
  }
  toast.dismiss(toastID);
  return response;
};

export const getTasksService = async (data, showToast = true) => {
  const toastId = showToast ? toast.loading("Fetching logs...") : null;
  let response;

  try {
    response = await axios.post(
      `${config.url.AIRFLOW}/api/airflow/get_task_level_for_logs`,
      data
    );
  } catch (_) {
    if (showToast) {
      toast.error("Error while fetching logs.");
    }
  }
  if (toastId) {
    toast.dismiss(toastId);
  }
  return response;
};

export const getTasksAcrossDagsService = async (data, showToast = true) => {
  const toastId = showToast ? toast.loading("Fetching task history...") : null;
  let response;

  try {
    response = await axios.post(
      `${config.url.AIRFLOW}/api/airflow/get_task_level_accross_dags`,
      data
    );
  } catch (_) {
    if (showToast) {
      toast.error("Error while fetching workflow history.");
    }
  }
  if (toastId) {
    toast.dismiss(toastId);
  }
  return response;
};
